// React Thirty Party Library
// import { Empty } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";

// Constants Library

// Components Library 
import { TableReport, DriverChart } from "../../components"
import Loading from "../../../../components/Loading"
import Page from '../../../../components/Decoration/Page'
import { EmptyIndicator } from "../../../../components/Indicator";
import DriverPerformanceDashboard from "../DriverPerformanceDashboard";

// Handler Library
import { reportHDLR } from "../../handler"

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";
// import PretripSummary from "../PretripSummary";
import Pretrip from "../Pretrip";

// Redux Actions

// Styles Library

const { reduxStoreWrapper } = REDUX_UTIL;

const MainReport = (props) => {
  const { type } = props

  const loading = useSelector(reduxStoreWrapper("style.loading.report"));
  const mode = useSelector(reduxStoreWrapper("reports.mode"));

  const [showTable, setShowTable] = useState(mode ? true : false)
  const [selectedType, setSelectedType] = useState(type);

  const { dataColumn, dataReport = [], fileName, ModalDriver, drawerPretripHDLR } = reportHDLR(selectedType)

  const searchItems = {
    showTable, 
    setShowTable,
    selectedType,
    setSelectedType,
    dataColumn,
    dataReport,
    fileName
  }

  const tableItems = {
    dataColumn,
    dataReport,
    fileName,
    ModalDriver,
    drawerPretripHDLR,
    startTime: props.startTime,
    endTime: props.endTime
  } 
  
  const title = `${selectedType === 'device' ? 'Device' : 'Driver'} Report`

  return (
     <div className = 'page-container'> 
        <Page title = {title}>
            <div style={{ display: 'flex', flexDirection: 'column'}}>

              {React.isValidElement(props.search) ? (
                React.cloneElement(props.search, searchItems)
              ) : null}

                {loading ? (
                  <Loading />
                  ) : 
                //   showTable ? (
                  <div>
                    {selectedType === 'performance' && <DriverChart />}
                    { (selectedType === 'pretrip') && dataReport.length && <Pretrip {...tableItems} /> || ''}
                    { selectedType !== 'pretrip' && selectedType !== 'driverScoring' && dataReport.length && <TableReport {...tableItems} /> || ''}
                    { selectedType && (selectedType !== 'driverScoring') && !dataReport?.length && <EmptyIndicator /> || ''}
                    { (selectedType === 'driverScoring') && dataReport?.length && <DriverPerformanceDashboard /> || ''}
                  </div>
                // ) 
                // : (
                //   <div style={{marginTop: "3%"}}>
                //   <Empty />
                // </div>
                // )
                }
            </div>     
        </Page>
     </div>
  );
};

export default MainReport;